var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableInsert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3C2.45 3 2 3.45 2 4V20C2 20.55 2.45 21 3 21H21C21.55 21 22 20.55 22 20V4C22 3.45 21.55 3 21 3ZM4 5H20V7H4V5ZM14 13H10V9H14V13ZM20 13H16V9H20V13ZM8 9V13H4V9H8ZM4 19V15H8V19H4ZM10 19V15H14V19H10ZM16 19V15H20V19H16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableInsert);
export default __webpack_public_path__ + "static/media/icon-table-insert.8b7be333004cf27259058dd4cc85fa0c.svg";
export { ForwardRef as ReactComponent };